import React from "react";
import { Avatar, Card, Col, Row, Tabs, Typography } from "antd";
import { Link } from "react-router-dom";

import BaseComponent from "../../redare/components/BaseComponent";
import { UserOutlined } from '@ant-design/icons';
import UserApplicationPresenter from "../../.gen/presenter/UserApplicationPresenter";
import ApplicationPresenter from "../../.gen/presenter/ApplicationPresenter";
import TaskReceiverGrid from "../../components/workbench/TaskReceiverGrid";
import IdInfo from "./IdInfo";

const { Text } = Typography;
const { Paragraph } = Typography;
const { TabPane } = Tabs;


export default class WorkbenchPage extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            modal1Visible: false,
            applicationList: []
        };
        this.applicationPresenter = new ApplicationPresenter(this);
        this.userApplicationPresenter = new UserApplicationPresenter(this);
    }

    componentDidMount() {
        this._loadApplicationList();
    }

    _loadApplicationList() {
        this.applicationPresenter.findApplicationOfUserList(
            { classify: "application", isShowPC: 1 },
            {},
            (result) => {
                this.setState({ applicationList: result.data });
            });
    }
    getCookie(name) {
        const cookies = document.cookie.split(";"); // 将所有cookie拆分成一个数组
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            const cookieName = cookie.substring(0, name.length);
            if (cookieName === name) {
                return decodeURIComponent(cookie.substring(name.length + 1, cookie.length));
            }
        }
        return null; // 如果找不到对应的cookie，则返回null
    }
    _JumpUrl(item, openUrl) {
        let ssoToken = window._workbench._ssoToken;
        let token = "";
        if (ssoToken) {
            token = ssoToken.token;
        }
        let sso_token = this.getCookie("sso_token");
        // console.log(token, sso_token, openUrl);

        // return
        if (item.appAccessUrl && !openUrl) {
            if (item.verifyAccountAndPwd === 0) {
                window.open(item.appAccessUrl + "?sso_token=" + sso_token, "_blank");
            } else {
                window.open(item.appAccessUrl + "?token=" + token, "_blank");
            }
        } else if (openUrl) {
            window.open(item.appAccessUrl, "_blank");
        } else {
            this.toastFail("建设中...");
        }
    }

    //单点跳转
    _doLoginRedirect(item, status) {
        const Jump = () => {
            if (item.status === 1) {
                if (item.verifyAccountAndPwd === 1) {
                    this.userApplicationPresenter.findByUserAndAppId({
                        applicationId: item.applicationId,
                        pcOrMobile: 1
                    }, {}, (result) => {
                        let application = result.data;
                        if (application) {
                            if (application.accountId === undefined || application.accountId === '') {
                                this.setState({ modal1Visible: true, item });
                            } else {
                                this._JumpUrl(item, false);
                            }
                        }
                    })
                } else {
                    this._JumpUrl(item, false);
                }
            } else {
                this.toastFail("建设中...");
            }
        }
        if (status) {
            Jump();
        } else if (window.location.host == "sykjinfo.ynshine.com" && window._workbench._user.realNameAuth == 0 && item.accessCode == "redare_pm") {
            // } else if (window._workbench._user.realNameAuth == 0 && item.accessCode == "redare_pm") {
            this.setState({ PmId: item });
        } else {
            Jump();
        }
    }

    _onTabSearch(value) {
        if (value.trim() === '') {
            this.toastFail("请输入搜索关键词");
        } else {
            this.props.history.push({ pathname: "/search", state: { searchValue: value.trim() } });
        }
    }

    render() {
        let { applicationList } = this.state;
        let user = window._workbench?._user ?? {};
        return (
            <div className="Workbench-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Row gutter={24} type="flex" justify="space-between" align="middle">
                            <Col>
                                <Row gutter={16} type="flex" align="middle">
                                    <Col>
                                        <Avatar icon={<UserOutlined />} size="large" src={user.photo} />
                                    </Col>
                                    <Col>
                                        <p className="title font20">
                                            <Text>您好，{user.name}</Text>
                                        </p>
                                    </Col>
                                </Row>
                            </Col>
                            {/*<Col>*/}
                            {/*    <Space size={16}>*/}
                            {/*        <Search*/}
                            {/*            placeholder="请输入关键词"*/}
                            {/*            enterButton="搜索"*/}
                            {/*            size="middle"*/}
                            {/*            onSearch={this._onTabSearch.bind(this)}*/}
                            {/*        />*/}
                            {/*    </Space>*/}
                            {/*</Col>*/}
                        </Row>
                    </div>
                </div>
                <div className="width-all">
                    <div className="margin-top24">
                        <Row gutter={24}>
                            <Col span={16}>
                                <Tabs defaultActiveKey="1" className="bg-white tab-box"
                                    tabBarExtraContent={<Link to="/task/receive" className="more">更多</Link>}>
                                    <TabPane tab={<><span>待办</span></>} key="1">
                                        <TaskReceiverGrid showPage={false} />
                                    </TabPane>
                                </Tabs>
                            </Col>
                            <Col span={8}>
                                <Card title="快捷登录" bordered={false}
                                    className="my-message"
                                    extra={<Link to="/unified">更多应用</Link>}>
                                    <div style={{ height: 436 }}>
                                        <Row className="icon-item" gutter={8} type="flex" align="bottom">
                                            {
                                                applicationList.map(item => {
                                                    return (
                                                        <Col span={6} key={item.id}>
                                                            <a onClick={() => this._doLoginRedirect(item)} target="_blank">
                                                                <img className="img" src={item.icon === undefined ? "" : item.icon} />
                                                                <p>{item.name}</p>
                                                            </a>
                                                        </Col>
                                                    );
                                                })
                                            }
                                        </Row>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
                <IdInfo PmId={this.state.PmId} _doLoginRedirect={this._doLoginRedirect.bind(this)} cancel={() => { this.setState({ PmId: false }) }} />
            </div>
        )
    }
}
